import { inject } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { AppVersion } from '@core';
import { UpdateService } from '@update/infra';
import { DashboardMessageId, DashboardMessageQueryResult } from '../../../models/dashboard-message.query-result';
import { DashboardMessagesStorage } from '../../../../infrastructure/storage/dashboard-messages.storage';

export class DashboardUpdateMessageQueryHandler {
  private readonly updateService: UpdateService = inject(UpdateService);
  private readonly storage: DashboardMessagesStorage = inject(DashboardMessagesStorage);

  message(): Observable<DashboardMessageQueryResult | null> {
    return combineLatest([this.updateService.newestVersion(), this.storage.dismissedUpdateVersion$]).pipe(
      map(([newestVersion, dismissedVersion]: [string, string | null]) =>
        this.toMessage(newestVersion, dismissedVersion)
      )
    );
  }

  private toMessage(newestVersion: string, dismissedVersion: string | null): DashboardMessageQueryResult | null {
    if (newestVersion === AppVersion) {
      return null;
    }

    if (dismissedVersion === newestVersion) {
      return null;
    }

    return {
      id: DashboardMessageId.Update,
      priority: 1,
      title: 'Dostępna nowa aktualizacja',
      subtitle: 'Zaktualizuj aplikację teraz, by korzystać z najnowszej wersji!',
      hasIcon: false,
      clickable: true,
      action: 'close',
      dismissToken: newestVersion
    };
  }
}
